(function () {
    'use strict';

    angular
        .module('dialog', [])
        .factory('dialog', dialog);

    dialog.$inject = ["$uibModal", '$translate', '$q'];

    function dialog($uibModal, $translate, $q) {
        var factory = this;

        factory.info = info;
        factory.prompt = prompt;

        function info(name) {
            $uibModal.open({
                animation: false,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                template: ` <div class="modal-header pb-0">
                                <svg class="mouse-pointer pull-right" ng-click="vm.close()"><use xlink:href="#icon-x"></use></svg>
                                <p class="modal-title" translate="`+ name.replace(/-/g, '_') + `"></p>
                            </div>
                            <div class="modal-body pb-0">
                                <div class="row dialog-text">
                                    <div class="col-md-12 padding-adjust">
                                    <p translate="`+ name.replace(/-/g, '_') + `..."></p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <div class="row">
                                    <div class="col-md-12 padding-adjust text-left font-semibold font-16">
                                    </div>
                                </div>
                            </div>`,
                windowClass: name + '-modal',
                controller: ['$uibModalInstance', '$timeout', function ($uibModalInstance, $timeout) {
                    var vm = this;
                    vm.close = function () {
                        $timeout(function () {
                            $uibModalInstance.dismiss();
                        }, 300);
                    };
                }],
                controllerAs: 'vm',
                size: 'sm'
            });
        }

        /**
         * A simple popup modal with a cancel/confirm prompt.
         * Returns a promise as an alternative to the callback function
         */
        async function prompt(name, callback, alternative, noOrange, translateValues) {
            callback = callback || function() {};
            name = name.replace(/-/g, '_');
            const [title, body, confirm] = await $q.when(Promise.all([
                $translate(name, translateValues || {}),
                $translate(name + '...', translateValues || {}),
                $translate(name + '_confirm', translateValues || {})
            ]));
            const instance = $uibModal.open({
                animation: false,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                template: ` <div class="modal-header pb-0">
                                <svg class="mouse-pointer pull-right" ng-click="vm.close()"><use xlink:href="#icon-x"></use></svg>
                                <p class="modal-title">` + title + `</p>
                            </div>
                            <div class="modal-body pb-0">
                                <div class="row">
                                    <div class="col-md-12 padding-adjust">
                                        <p>` + body + `</p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <div class="row">
                                    <div class="col-md-12 padding-adjust text-center font-semibold font-16">
                                        <button class="medium mb-10 mr-1 ghost" ng-click="vm.` + (alternative ? "alternative" : "close") + `()" translate="` + (alternative ? name.replace(/-/g, '_') + "_alternative" : "cancel") + `"></button>
                                        <button class="medium mb-10 ` + (noOrange ? "" : "orange") + `" ng-click="vm.confirm()">` + confirm + `</button>
                                    </div>
                                </div>
                            </div>`,
                windowClass: name + '-modal',
                controller: ['$uibModalInstance', '$timeout', function ($uibModalInstance, $timeout) {
                    var vm = this;
                    vm.close = function () {
                        $timeout(function () {
                            $uibModalInstance.close({
                                confirm: false,
                            });
                        }, 300);
                    };
                    vm.confirm = function () {
                        $uibModalInstance.close({
                            confirm: true,
                        });
                    }
                    vm.alternative = function () {
                        $uibModalInstance.close({
                            alternative: true,
                        });
                    }
                }],
                controllerAs: 'vm',
                size: 'sm',
                backdrop: 'static'
            });
            try {
                const result = await $q.when(instance.result);
                callback(result);
                return result;
            } catch (err) {
                callback(err);
                return err;
            }
        }

        return factory;
    }
})();